// src/utils/cookies.ts

export type CookieOptions = {
    days?: number;
    path?: string;
    domain?: string;
    secure?: boolean;
    sameSite?: "Lax" | "Strict" | "None";
};

/**
 * Set a browser cookie
 */
export function setCookie(
    name: string,
    value: string,
    options: CookieOptions = {}
) {
    const {
        days = 60,
        path = "/",
        domain,
        secure = false,
        sameSite = "Lax",
    } = options;

    const expires = new Date(
        Date.now() + days * 24 * 60 * 60 * 1000
    ).toUTCString();

    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=${path}; SameSite=${sameSite}`;

    if (domain) cookie += `; domain=${domain}`;
    if (secure) cookie += `; Secure`;

    document.cookie = cookie;
}

/**
 * Get a cookie value by name
 */
export function getCookie(name: string): string | null {
    const encodedName = encodeURIComponent(name) + "=";

    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
        if (cookie.startsWith(encodedName)) {
            return decodeURIComponent(cookie.substring(encodedName.length));
        }
    }
    return null;
}

/**
 * Delete a cookie
 */
export function deleteCookie(
    name: string,
    path: string = "/",
    domain?: string
) {
    setCookie(name, "", {
        days: -1,
        path,
        domain,
    });
}
